import { render, staticRenderFns } from "./DomainsCounter.vue?vue&type=template&id=406b5438&scoped=true"
import script from "./DomainsCounter.vue?vue&type=script&lang=js"
export * from "./DomainsCounter.vue?vue&type=script&lang=js"
import style0 from "./DomainsCounter.vue?vue&type=style&index=0&id=406b5438&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406b5438",
  null
  
)

export default component.exports